import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import LicenseMessage from '../../../../../../../../LicenseMessage';
import NextButton from '../../../../../../../../NextButton';
import SelectedUsers from '../../../../../../../../SelectedUsers';
import InviteParticipantStore from '../../../../../../Store';
import { GroupOrParticipantResource } from '../../../../../../Types';

export interface Props {
  store: InviteParticipantStore;
  activationsRemaining: Maybe<number>;
  title: string;
  newLicenseAllocations: number;
  allocatedLicenses: number;
  newGroupsAndParticipants: ReadonlyArray<GroupOrParticipantResource>;
}

function Participants({
  store,
  activationsRemaining,
  title,
  newLicenseAllocations,
  allocatedLicenses,
  newGroupsAndParticipants,
}: Props) {
  return (
    <>
      <div className="max-h-60 h-60 text-sm overflow-y-auto">
        <SelectedUsers
          newGroupsAndParticipants={newGroupsAndParticipants}
          removeGroup={store.removeGroup}
          removeParticipant={store.removeParticipant}
        />
      </div>
      <LicenseMessage
        activationsRemaining={activationsRemaining}
        title={title}
        newLicenseAllocations={newLicenseAllocations}
        allocatedLicenses={allocatedLicenses}
      />
      <NextButton
        inviting={store.inviting}
        submit={store.submit}
        activationsRemaining={activationsRemaining}
      />
    </>
  );
}

export default observer(Participants);
